let regModel: any;
let addressModel: any;

export const setSessionData = (model: any, type: string) => {
    if (type == "step1") {
        regModel = model;
    }
    if (type == "step2") {
        addressModel = model;
    }
};

export const getSessionData = (type: any) => {
    if (type == "step1") {
        return regModel;
    }
    if (type == "step2") {
        return addressModel;
    }
};
